// Step 7a of the client-side X12 pipeline: the inverse of the tokenizer.
// Re-emits a flat segment array as raw X12 text, using the exact delimiters
// detected from the original document's ISA segment — an edit never changes
// which characters separate elements, sub-elements or segments, only the
// values inside them.

import type {EdiDelimiters, EdiElementValue, EdiSegment} from './tokenizer';

function serializeElement(
  value: EdiElementValue,
  delimiters: EdiDelimiters
): string {
  return Array.isArray(value) ? value.join(delimiters.subElement) : value;
}

function serializeSegment(
  segment: EdiSegment,
  delimiters: EdiDelimiters
): string {
  const parts = [
    segment.id,
    ...segment.elements.map(element => serializeElement(element, delimiters)),
  ];
  return parts.join(delimiters.element) + delimiters.segmentTerminator;
}

/**
 * Re-emits a flat segment array (in order) as raw X12 text, one segment per
 * line for readability — the segment terminator itself is what a real
 * consumer parses on, so the trailing newline is cosmetic only.
 */
export function serialize(
  delimiters: EdiDelimiters,
  segments: EdiSegment[]
): string {
  return segments
    .map(segment => serializeSegment(segment, delimiters))
    .join('\r\n');
}
